/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import espInfo, { EspKey } from 'cio/utils/email-service-providers';

import MailServerModel from 'cio/models/mail-server';
import { SetupSubStep } from 'cio/components/custom-smtp-settings/create-server-modal';

interface CreateServerModalSetupStepArgs {
  selectedEsp: EspKey;
  server: MailServerModel;
  confirmedWebhookSetup: boolean;
  isSaving: boolean;
  onClose: () => unknown;
  onGoBack: () => unknown;
  onContinue: () => unknown;
  onConfirmWebhookSetup: () => unknown;
  onSave: () => unknown;
  onSkipWebhookSetup: () => unknown;
  setupSubStep: SetupSubStep;
  setSetupSubStep: (subStep: SetupSubStep) => unknown;
}

export default class CreateServerModalSetupStep extends Component<CreateServerModalSetupStepArgs> {
  readonly EspKey = EspKey;

  get selectedEspInfo() {
    return espInfo(this.args.selectedEsp);
  }

  @action
  confirmWebhookSetup() {
    this.args.onConfirmWebhookSetup();
    this.args.setSetupSubStep(SetupSubStep.Credentials);
  }
  @action
  skipWebhookSetup() {
    this.args.onSkipWebhookSetup();
    this.args.setSetupSubStep(SetupSubStep.Credentials);
  }

  constructor(owner: unknown, args: CreateServerModalSetupStepArgs) {
    super(owner, args);

    this.args.setSetupSubStep(this.selectedEspInfo.supportsWebhooks ? SetupSubStep.Webhooks : SetupSubStep.Credentials);
  }
}
